import { makeAutoObservable } from "mobx";
import { ScienceEntity } from "../entity/science-entity";
import { RcFile } from "antd/es/upload";
import { PageEntity } from "../entity/page-entity";
import { CommentEntity } from '../entity/comment-entity';

export class ScienceStore {
    constructor() {
        makeAutoObservable(this);
    }

    public condition: any = this.getDefaultCondition();
    public commentCondition: any = this.getDefaultCommentCondition();
    public dataSource: ScienceEntity[] = [];
    public commentSource: CommentEntity[] = [];
    public selectRows: ScienceEntity[] = [];
    public showBaseLibraryDetail:ScienceEntity|undefined;
    public isShowDetail = false;
    public isShowEdit = false;
    public isShowUpload = false;
    public isShowOff = false;
    public isShowRelease = false;
    public isShowTopping = false;
    public isShowCancelTopping = false;
    public detailType: string = "add";
    public srcFile: any;
    public srcCoverFile: any;
    public fileList: RcFile[] = [];
    public fileCoverList: RcFile[] = [];
    public pagination:PageEntity = new PageEntity();
    public isShowDeleteCOnfirm = false;
    public deleteRecord!: ScienceEntity;
    public deleteCommentRecord!: CommentEntity;
    public offRecord!: ScienceEntity;
    public releaseRecord!: ScienceEntity;
    public toppingRecord!: CommentEntity;
    public comment: string = '';
    public userName: string = '';

    private getDefaultCondition() {
        return {
            category: "", 
            title: "", 
            source: "",
            creater: "",
            autor: "",
        };
    }

    private getDefaultCommentCondition() {
        return {
            userid: "", 
            anonymous: -1
        };
    }

    public setDataSource(list: ScienceEntity[]){
        this.dataSource = list;
    }

    public setCommentSource(list: CommentEntity[]) {
        this.commentSource = list;
    }

    public resetScienceCondition() {
        this.condition = this.getDefaultCondition();
    }

    public resetScienceCommentCondition() {
        this.commentCondition = this.getDefaultCommentCondition();
    }

    public setSelectedRows(selectRows: ScienceEntity[]){
        this.selectRows = selectRows;
    }

    public setBaseLibraryDetail(detail:ScienceEntity) {
        this.showBaseLibraryDetail = detail;
    }

    public setShowDetail(isShow:boolean){
        this.isShowDetail = isShow;
    }

    public setShowEdit(isEdit:boolean){
        this.isShowEdit = isEdit;
    }

    public setShowOff(isEdit:boolean){
        this.isShowOff = isEdit;
    }

    public setShowUpload(isUpload:boolean) {
        this.isShowUpload = isUpload;
    }

    public setShowRelease(isUpload:boolean) {
        this.isShowRelease = isUpload;
    }

    public setShowTopping(isShow:boolean) {
        this.isShowTopping = isShow;
    }

    public setShowCancelTopping(isShow:boolean) {
        this.isShowCancelTopping = isShow;
    }
    
    public clearSelectedRows(){
        this.selectRows = [];
    }

    public clearDetail = () => {
        this.showBaseLibraryDetail = undefined;
    }

    public setDetailType (type:string) {
        this.detailType = type;
    }

    public setSrcFile (srcfile: any) {
        this.srcFile = srcfile;
    }

    public setSrcCoverFile(srcfile: any) {
        this.srcCoverFile = srcfile;
    }

    public setFilelist(file:RcFile) {
        this.fileList = [];
        this.fileList.push(file);
    }

    public setFileCoverList(file:RcFile) {
        this.fileCoverList = [];
        this.fileCoverList.push(file);
    }

    public clearFileList = () =>  {
        this.fileList = [];
    }

    public clearFileCoverList = () =>  {
        this.fileCoverList = [];
    }

    public showDeleteConfirm(isShow:boolean){
        this.isShowDeleteCOnfirm = isShow;
    }

    public setDeleteRecord(record: ScienceEntity) {
        this.deleteRecord = record;
    }

    public setDeleteCommentRecord(record: CommentEntity) {
        this.deleteCommentRecord = record;
    }

    public setOffRecord(record: ScienceEntity) {
        this.offRecord = record;
    }

    public setReleaseRecord(record: ScienceEntity) {
        this.releaseRecord = record;
    }

    public setToppingRecord(record: CommentEntity) {
        this.toppingRecord = record;
    }

    public setComment(str: string) {
        this.comment = str;
    }
    
    public setUserName(name: string) {
        this.userName = name;
    }
    public clearComment() {
        this.comment = '';
        this.userName = '';
    }
    public clear = () => {
        this.condition = this.getDefaultCondition();
        this.commentCondition = this.getDefaultCommentCondition();
        this.dataSource = [];
        this.selectRows = [];
        this.showBaseLibraryDetail = undefined;
        this.isShowDetail = false;
        this.isShowEdit = false;
        this.isShowUpload = false;
        this.srcFile = null;
        this.fileList = [];
        this.pagination = new PageEntity();
        this.isShowDeleteCOnfirm = false;
        this.deleteRecord = {} as ScienceEntity;
    }
}